/**
 * Web stub for `react-native-url-polyfill`. Constructing it throws, which keeps
 * web callers (`forceProtocol`, `parseDeepLink`) on their existing fallback
 * paths. Swapping in the browser's `URL` would make `parseDeepLink` start
 * resolving app links on web.
 */
export class URL {
    constructor(_url) {
        throw new Error('URL polyfill is not available on web');
    }
}
